import {createContext} from "react";
import {User} from "../model/User";





export type AuthContextType = {
    user: User | null;
    signIn: (username: string, password: string) => Promise<boolean>;
    signOut: () => void;
}


// @ts-ignore
export const AuthContext = createContext<AuthContextType>();